// Module
var code = "<span class=\"field-icons-feature-icon\" ng-class=\"'field-icons-feature-icon--' + $ctrl.size\" aria-hidden=\"true\"> <i ng-class=\"$ctrl.iconClass || 'fa-light fa-square'\"></i> </span> ";
// Exports
export default code;